import React from "react";
import clsx from "clsx";
import R from "ramda";
import PropTypes from "prop-types";
import { Divider, Typography } from "@material-ui/core";

import useStyles from "./useStyles";

const SectionHeader = (props) => {
  const { children, first } = props;
  const classes = useStyles();

  return (
    <>
      <Typography variant="h2" className={clsx(classes.title, R.isNil(first) && classes.margin)}>
        {children}
      </Typography>

      <Divider className={classes.divider} />
    </>
  );
};

SectionHeader.propTypes = {
  first: PropTypes.bool,
};

export default SectionHeader;
